/**
 * @generated SignedSource<<d081adc67401f21b27ac66c817eefc31>>
 * @relayHash 3c9c75fd98adfad974db20e749ca9f92
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3c9c75fd98adfad974db20e749ca9f92

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type de_BetterDocExchangeOperation = "CONFIRM_RECOMMENDATION_RESULTS" | "CONFIRM_SELECTED_MEDICS" | "CREATE_RECOMMENDATION" | "GET_RECOMMENDATION" | "LIST_RECOMMENDATIONS" | "LIST_RECOMMENDED_RECOMMENDATIONS" | "LIST_SELECTED_RECOMMENDATIONS" | "SEARCH_CARE_PROVIDERS" | "SELECT_MEDIC" | "SEND_REFERRAL_SLIP" | "SIMULATE_PATIENT_SELECTION" | "SIMULATE_RESEARCH" | "SIMULATE_SECOND_OPINION_VISIT_CONFIRMATION";
export type de_BetterDocExchangeOutcome = "CANCELLED" | "FAILED" | "PENDING" | "RESPONDED" | "TIMED_OUT" | "TOKEN_UNAVAILABLE";
export type de_BetterDocNavigationType = "MSN" | "NO_NAVIGATION" | "PMN";
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocTestCaseScenario = "MSN" | "MSN_WITH_SECOND_OPINION" | "PMN";
export type betterDocLookupQuery$variables = {
  identifier: string;
};
export type betterDocLookupQuery$data = {
  readonly de_betterDocLookup: {
    readonly exchange: {
      readonly actor: string;
      readonly durationMilliseconds: number | null;
      readonly exchangeId: number;
      readonly failureKind: string | null;
      readonly hasUnexpectedResponse: boolean;
      readonly httpMethod: string;
      readonly isTestCase: boolean;
      readonly operation: de_BetterDocExchangeOperation;
      readonly outcome: de_BetterDocExchangeOutcome;
      readonly requestUri: any;
      readonly responseStatusCode: number | null;
      readonly startedAt: string;
    } | null;
    readonly sessions: ReadonlyArray<{
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly createdAt: string;
      readonly createdBy: string;
      readonly insuranceCountry: Country | null;
      readonly isTestCase: boolean;
      readonly navigationType: de_BetterDocNavigationType | null;
      readonly partnerPatientId: string;
      readonly partnerSessionId: string;
      readonly progressNoteId: number | null;
      readonly sessionId: number;
      readonly testCaseScenario: de_BetterDocTestCaseScenario | null;
    }>;
  };
};
export type betterDocLookupQuery = {
  response: betterDocLookupQuery$data;
  variables: betterDocLookupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "identifier"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTestCase",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "identifier",
        "variableName": "identifier"
      }
    ],
    "concreteType": "de_BetterDocLookupResult",
    "kind": "LinkedField",
    "name": "de_betterDocLookup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocSessionSummary",
        "kind": "LinkedField",
        "name": "sessions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerPatientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressNoteId",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "testCaseScenario",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "navigationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insuranceCountry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "betterDocState",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdBy",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocExchangeSummary",
        "kind": "LinkedField",
        "name": "exchange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "exchangeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "operation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "httpMethod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestUri",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasUnexpectedResponse",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatusCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationMilliseconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "outcome",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failureKind",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocLookupQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocLookupQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "3c9c75fd98adfad974db20e749ca9f92",
    "metadata": {},
    "name": "betterDocLookupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ba87e2f7490eff2b8205c501e5531c2e";

export default node;
